"use client";
import { useEffect, useRef } from "react";
export default function useCombinedRefs(...refs) {
    const targetRef = useRef(null);
    useEffect(() => {
        for (const ref of refs) {
            if (!ref)
                continue;
            ref.current = targetRef.current;
        }
    }, refs); // eslint-disable-line react-hooks/exhaustive-deps
    return targetRef;
}
//# sourceMappingURL=use-combined-refs.js.map